// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3pSvM","info":"UpdateTermsInfo_info__33Wqj"};